import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
    BillOfLadingDTO,
    CreateBillOfLadingRequest,
    PageResponse,
    UpdateBillOfLadingRequest,
} from '../interfaces/commercial.interface';

/** Bill of lading / forwarder (15.3) — flat header, no children. Returns data only — components
 * own triggerDownload/showApiError per house rules (mirrors exportLc.service). */
export const BillOfLadingService = {
    list: async (institutionId: string, page = 0, size = 20): Promise<PageResponse<BillOfLadingDTO>> =>
        (await axios.get(`${ENDPOINTS.BILL_OF_LADING.LIST(institutionId)}?page=${page}&size=${size}`)).data,
    getById: async (institutionId: string, id: string): Promise<BillOfLadingDTO> =>
        (await axios.get(ENDPOINTS.BILL_OF_LADING.GET_BY_ID(institutionId, id))).data,
    create: async (institutionId: string, dto: CreateBillOfLadingRequest): Promise<BillOfLadingDTO> =>
        (await axios.post(ENDPOINTS.BILL_OF_LADING.CREATE(institutionId), dto)).data,
    update: async (institutionId: string, id: string, dto: UpdateBillOfLadingRequest): Promise<BillOfLadingDTO> =>
        (await axios.put(ENDPOINTS.BILL_OF_LADING.UPDATE(institutionId, id), dto)).data,
    remove: async (institutionId: string, id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.BILL_OF_LADING.DELETE(institutionId, id));
    },

    // ---- pdf ------------------------------------------------------------------------------------
    downloadBillOfLadingPdf: async (institutionId: string, id: string): Promise<Blob> =>
        (await axios.get(ENDPOINTS.BILL_OF_LADING.PDF(institutionId, id), { responseType: 'blob' })).data,
};
